<template>
<div>
     <m-edit-emails
        label="Send Invoices to (email addresses)"
        v-model="organization_settings_rate_card.send_invoice_to_customer_emails"
        style="margin-bottom:15px"
        v-on:input="patch"
    />
</div>
</template>

<script>
const _ = require('lodash');
export default {

    props: {
        organization_id: {
            type: String,
            default: function() { return null; }
        },
    },

    data() {
        return {
            organization_settings_rate_card: null,
        }
    },

    mounted () {
        this.getProfile();
    },

    methods: {
        getProfile()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/billing/organization/rate-card-profile/:organization_id',
            
                'params' : {
                        'organization_id': this.organization_id,
                    },
            
                'on_success': (data) => {
                        this.organization_settings_rate_card = data.organization_settings_rate_card;
                    },
            
                'on_error': 'Unable to get billing profile',
            });
        },

        patch: _.debounce(function(){
            this.doPatch();
        }, 751),
        
        doPatch()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PATCH: /api/v1/billing/organization/org-controlled-billing-settings',
            
                'params' : {
                        'organization_id': this.organization_id,
                        'send_invoice_to_customer_emails': this.organization_settings_rate_card.send_invoice_to_customer_emails,
                    },
            
                'on_success': (data) => {
                        
                    },
            
                'on_error': 'Unable to save send invoice to email addresses.',
            });
        },
        
        
    },
}
</script>

<style lang="scss" scoped>

</style>